{
  "en": {
    "lot": {
      "attributes": {
        "end_date": "End date",
        "internal_note": "Plot internal note",
        "land_register": "Land register",
        "name": "Name",
        "start_date": "Start date",
        "surface": "Area"
      },
      "labels": {
        "lot": "No plot | One plot | {count} Plots"
      },
      "toasts": {
        "create": "Plot created",
        "delete": "Plot deleted",
        "update": "Plot updated"
      },
      "validation": {
        "needName": "Title is required",
        "needNumber": "Must be a number (e.g. 85)"
      }
    }
  }
}
